import { Box, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: '70px',
  },
  title: {
    color: '#212121',
    fontFamily: 'Playfair Display',
    fontSize: '36px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '54px',
    [theme.breakpoints.down('lg')]: {
      fontSize: '24px',
      lineHeight: '36px',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '18px',
      lineHeight: '27px',
    },
  },
}));

function EventsTabContent() {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Box>
        <Typography className={classes.title}>Events</Typography>
      </Box>
      <Box style={{ height: 600 }}>
        <iframe
          src="https://calendar.google.com/calendar/embed?src=d40ef2cc408094f3568867bdcfb971692deaf925d9f268d1b8f288d852ead15e%40group.calendar.google.com&ctz=America%2FNew_York"
          style={{ border: 0, width: '100%', height: '100%' }}
          frameBorder="0"
          scrolling="no"
        ></iframe>
      </Box>
    </Box>
  );
}

export default EventsTabContent;
